import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, MapPin } from 'lucide-react';
const PURCHASES = [{
  name: 'María G.',
  country: 'Argentina'
}, {
  name: 'Carlos T.',
  country: 'México'
}, {
  name: 'Valentina R.',
  country: 'Colombia'
}, {
  name: 'Joaquín M.',
  country: 'Chile'
}, {
  name: 'Sebastián L.',
  country: 'Perú'
}, {
  name: 'Camila F.',
  country: 'Uruguay'
}, {
  name: 'Nicolás P.',
  country: 'España'
}, {
  name: 'Luciana D.',
  country: 'Ecuador'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 4000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showNotification = () => {
    // Select random purchase
    const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next appearance (random between 8-15 seconds)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showNotification, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-112">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full" data-id="element-113">
          <div className="bg-gray-900/95 backdrop-blur-sm border border-gray-700 rounded-lg shadow-2xl p-4 flex items-center gap-4" data-id="element-114">
            <div className="bg-green-500/20 p-2 rounded-full flex-shrink-0" data-id="element-115">
              <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-116" />
            </div>
            <div data-id="element-117">
              <p className="text-sm font-bold text-white" data-id="element-118">
                {currentPurchase.name} acaba de comprar
              </p>
              <div className="flex items-center gap-1 text-xs text-gray-400 mt-0.5" data-id="element-119">
                <MapPin className="w-3 h-3" data-id="element-120" />
                <span data-id="element-121">de {currentPurchase.country}</span>
              </div>
              <p className="text-xs text-green-400 mt-1 font-medium" data-id="element-122">
                Verificado hace unos instantes
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}